import script from "./SingleSideCarouselItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./SingleSideCarouselItem.vue?vue&type=script&setup=true&lang=ts"

import "./SingleSideCarouselItem.vue?vue&type=style&index=0&id=0f9dfcad&scoped=true&lang=scss"

import exportComponent from "/home/centos/workspace/Blueshift Core/blueshift-frontend-PROD-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f9dfcad"]])

export default __exports__